import type { ReactNode } from 'react';
import { cn } from '@/utils/tailwind.util';
interface SettingSectionProps {
  /** 섹션 머리말. */
  title: string;
  children: ReactNode;
  className?: string;
}

/**
 * 설정 화면의 카드 한 장 (제목 + 본문). 퀴즈 제작 설정과 폴더 수정 화면이 함께 쓴다.
 *
 * 도메인을 모른다 — 폼 바인딩은 전부 children 쪽 몫이다.
 */
export const SettingSection = ({
  title,
  children,
  className
}: SettingSectionProps) => {
  return <div className={cn('bg-default p-xl rounded-md border border-assistive', className)} data-sentry-component="SettingSection" data-sentry-source-file="SettingSection.tsx">
      <h3 className={'mb-lg text-body-md-bold text-assistive'}>{title}</h3>
      <div className={'flex flex-col gap-lg'}>{children}</div>
    </div>;
};